import { useEffect, useRef, useState } from 'react'

const useTableScroll = () => {
  const tableContainerRef = useRef(null)
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(true)

  useEffect(() => {
    tableContainerRef.current.addEventListener('scroll', () => {
      const tableContainer = tableContainerRef.current
      setShowLeftArrow(tableContainer.scrollLeft > 100)
      setShowRightArrow(tableContainer.scrollLeft + tableContainer.clientWidth < tableContainer.scrollWidth)
    })
  }, [])

  const moveScroll = direction => {
    const scrollSize = 150
    const tableContainer = tableContainerRef.current

    if (direction === 'left') {
      tableContainer.scrollBy({ left: -scrollSize, behavior: 'smooth' })
    } else {
      tableContainer.scrollBy({ left: scrollSize, behavior: 'smooth' })
    }
  }

  return {
    tableContainerRef,
    showLeftArrow,
    showRightArrow,
    moveScroll,
  }
}

export default useTableScroll
